import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import App from './App.vue'
import './styles/global.scss'
import router from './router'
import ScrollAnimation from './directives/scrollAnimation'
import JQuery from 'jquery'
window.$ = JQuery

Vue.directive('scrollanimation', ScrollAnimation)

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
        installComponents: true,
    },
})

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
